import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { AuthService } from './core/auth/auth.service';
import { RouterOutlet } from '@angular/router';
import { OabConfirmHostComponent } from './shared/components/confirm-host.component';
import { OabProgressBarComponent } from './shared/components/progress-bar.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.html',
    imports: [
        RouterOutlet,
        OabConfirmHostComponent,
        OabProgressBarComponent,
    ],
})
export class AppComponent implements OnInit, OnDestroy {
    private authService = inject(AuthService);


    // Item 4: verifica periodicamente a expiração da sessão (cobre usuário ocioso).
    private sessionCheckHandle: any;

    ngOnInit() {
        this.authService.enforceSessionExpiration();
        this.sessionCheckHandle = setInterval(
            () => this.authService.enforceSessionExpiration(),
            30000
        );
    }

    ngOnDestroy() {
        if (this.sessionCheckHandle) {
            clearInterval(this.sessionCheckHandle);
        }
    }

}
